export default "__VITE_ASSET__BZ54tkop__"